import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects'
import axios from 'axios'
import {
  acceptAction,
  rejectAction,
} from '@Infowijs-eng/component-library/modules/reduxPromiseHelpers'
import { debounceAction } from '@Infowijs-eng/component-library/modules/authentication'
import { serviceEndpoints } from '@Infowijs-eng/component-library/modules'
import actionTypes from '../../action-types'
import fetchImporter from '../../actions/importers/fetchImporter'
import setImporter from '../../actions/importers/setImporter'
import awaitAccessToken from '../../modules/awaitAccessToken'

const onFetchImporter = function* onFetchImporter() {
  yield takeLatest(actionTypes.IMPORTERS.FETCH, function* onFetchImporterSaga(action) {
    const accessToken = yield call(awaitAccessToken)

    let response
    const { payload } = action

    try {
      response = yield call(axios, {
        url: `${serviceEndpoints.importers}/${payload}`,
        params: {
          include: 'administrator',
        },
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/vnd.infowijs.v1+json',
          Accept: 'application/vnd.infowijs.v1+json',
          'X-Infowijs-Client': 'nl.infowijs.admin',
        },
      })
    } catch (e) {
      if (e.response.status === 401) {
        yield debounceAction(function* reFetchImporter() {
          yield put(fetchImporter(payload))
        })
      }

      rejectAction(action, e.response.data && e.response.data.errors)
      return
    }

    if (response.status !== 204) {
      yield put(setImporter(response.data.data))
    }

    acceptAction(action, response.data.data || [])
  })
}

export default onFetchImporter
